import React, { Component } from "react";
import axios from "axios";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export class MaintenanceMessage extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      collapse: true,
      message: [],
      delay: 600000,
    };

    this.pollForMessage();
  }

  componentDidMount() {
    this.interval = setInterval(this.pollForMessage, this.state.delay);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.delay !== this.state.delay) {
      clearInterval(this.interval);
      this.interval = setInterval(this.pollForMessage, this.state.delay);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  pollForMessage = () => {
    var randomNumber = Math.floor(Math.random() * 1000000);
    axios
      .get(`${process.env.PUBLIC_URL}/message.json?v=` + randomNumber)
      .then((res) => {
        this.setState({ message: res.data.message });
      });
  };

  toggle = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  render() {
    if (this.state.message.length > 0) {
      return (
        <div>
          <span className="p-2" id="importantInfoIcon">
            <FontAwesomeIcon
              title="Info"
              icon="triangle-exclamation"
              style={{ cursor: "pointer" }}
              onClick={this.toggle}
            />
          </span>
          <Collapse
            isOpen={this.state.collapse}
            tag="h4"
            className="border-top border-bottom p-2"
            id="importantInfoText"
          >
            <span className="pe-2 ps-2">
              <FontAwesomeIcon
                title="close"
                icon="xmark"
                style={{ cursor: "pointer" }}
                onClick={this.toggle}
              />
            </span>
            {this.state.message}
          </Collapse>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default MaintenanceMessage;
